import { useHistory, useLocation } from "react-router";
import { GetWindowState, defaultReducer, usePageState } from "../../Utils";
import { useEffect, useState } from "react";
import hearth from "../../assets/ic_hearth_filled.svg";
import uPlot from "uplot";
import UplotReact from "uplot-react";
import "uplot/dist/uPlot.min.css";
import React from "react";
import { Box, Typography } from "@mui/material";
import {getTimeStringFromDate} from "../../TimeUtils";
import { Translate, translate } from "react-i18nify";
import { colors } from "../../Style";
import { calculateTrendInfoTestData, createAverageArray, generateTestChartData } from "./chartsUtils";
import { UPlotChart } from "./UPlotChart";
import { DownArrow } from "../../components/UI/Arrows";

export const TREND_MODE = {
  TREND_MODE_12_MIN: "12m",
  TREND_MODE_1_HOUR: "1h",
  TREND_MODE_8_HOUR: "8h",
  TREND_MODE_24_HOUR: "24h",
};

export const Trends = (props) => {
  const [time, setTime] = useState(Date.now());
  const [timestamps, setTimestamps] = useState([]);
  const deviceData = Array.from(props?.pro?.data);

  const deviceDataToTrendData = (data, length, mode) => {
    if (data == undefined || data.length == 0) {
      return [];
    }
    const time = [];
    const spo2 = [];
    const o2 = [];
    const pulse = [];
    const profileChange = [];
    const patientChange = [];
    const turnOnOff = [];
    const lastShutDown = getLastShutDownIndex(data)

    if(mode === TREND_MODE.TREND_MODE_12_MIN && lastShutDown > 0){
      data = data.slice(lastShutDown + 1, data.length)
    }
    data = data.reverse();
    for (let i = length; i >= 0; i--) {
      if (length - i > data.length) {
        break;
      }
      //If we ever fix null values not gapping we need to use this code to insert null values if the data is lower than 0 and use null instead.
      //spo2.push(data[length - i]?.spo2 < 0 ? null : data[length - i]?.spo2);
      //pulse.push(data[length - i]?.pulse < 0 ? null : data[length - i]?.pulse);
      //o2.push(data[length - i]?.o2 / 100 > 15 ? 15 : data[length - i]?.o2 <= 0 ? null : data[length - i]?.o2 / 100);
      time.push(i);
      spo2.push(data[length - i]?.spo2);
      pulse.push(data[length - i]?.pulse);
      o2.push(data[length - i]?.o2 / 100 > 15 ? 15 : data[length - i]?.o2 / 100);
      if (mode === TREND_MODE.TREND_MODE_12_MIN){
        profileChange.push(false)
        patientChange.push(false)
        turnOnOff.push(false)
      }else{
        profileChange.push(data[length - i]?.profileChange?true:false)
        patientChange.push(data[length - i]?.patientChange?true:false)
        turnOnOff.push(data[length - i]?.turnOnOff?true:false)
      }

    }
    return [time, spo2, pulse, o2,profileChange,patientChange,turnOnOff];
  };
  const history = useHistory();
  const location = useLocation();
  const state = GetWindowState();

  const defaultMenu = {
    LEFT: { label: "8h", route: TREND_MODE.TREND_MODE_8_HOUR, local: true },
    UP: { label: "TrendInfo", route: "trendInfo" },
    RIGHT: { label: "12m", route: TREND_MODE.TREND_MODE_12_MIN, local: true },
    MIDDLE: null,
    DOWN: { label: "Main", route: "home" },
  };

  const [pageState, setPageState] = usePageState(
    defaultReducer,
    state
      ? state
      : {
          menu: { ...defaultMenu },
          mode: TREND_MODE.TREND_MODE_1_HOUR,
        }
  );

  const updateNavigation = () => {
    setPageState((old) => {
      let menu = {};
      if (old.mode === TREND_MODE.TREND_MODE_12_MIN) {
        menu = {
          LEFT: {
            label: "1h",
            route: TREND_MODE.TREND_MODE_1_HOUR,
            local: true,
          },
          UP: { label: "TrendInfo", route: "trendInfo" },
          RIGHT: null,
          MIDDLE: null,
          DOWN: { label: "Main", route: "home" },
        };
      }
      if (old.mode === TREND_MODE.TREND_MODE_1_HOUR) {
        menu = {
          LEFT: {
            label: "8h",
            route: TREND_MODE.TREND_MODE_8_HOUR,
            local: true,
          },
          UP: { label: "TrendInfo", route: "trendInfo" },
          RIGHT: {
            label: "12m",
            route: TREND_MODE.TREND_MODE_12_MIN,
            local: true,
          },
          MIDDLE: null,
          DOWN: { label: "Main", route: "home" },
        };
      }

      if (old.mode === TREND_MODE.TREND_MODE_8_HOUR) {
        menu = {
          LEFT: {
            label: "24h",
            route: TREND_MODE.TREND_MODE_24_HOUR,
            local: true,
          },
          UP: { label: "TrendInfo", route: "trendInfo" },
          RIGHT: {
            label: "1h",
            route: TREND_MODE.TREND_MODE_1_HOUR,
            local: true,
          },
          MIDDLE: null,
          DOWN: { label: "Main", route: "home" },
        };
      }

      if (old.mode === TREND_MODE.TREND_MODE_24_HOUR) {
        menu = {
          LEFT: null,
          UP: { label: "TrendInfo", route: "trendInfo" },
          RIGHT: {
            label: "8h",
            route: TREND_MODE.TREND_MODE_8_HOUR,
            local: true,
          },
          MIDDLE: null,
          DOWN: { label: "Main", route: "home" },
        };
      }
      old.menu = menu;
      props.navigation.setMenu(menu);
      return old;
    });
  };

  const localNavigation = (navigator, action, menu) => {

    if (action.type == "CLICK") {
      switch (menu[action.button].route) {
        case TREND_MODE.TREND_MODE_12_MIN:
          setPageState((state) => {
            return {
              ...state,
              mode: TREND_MODE.TREND_MODE_12_MIN,
            };
          });
          break;
        case TREND_MODE.TREND_MODE_1_HOUR:
          setPageState((state) => {
            return {
              ...state,
              mode: TREND_MODE.TREND_MODE_1_HOUR,
            };
          });
          break;
        case TREND_MODE.TREND_MODE_8_HOUR:
          setPageState((state) => {
            return {
              ...state,
              mode: TREND_MODE.TREND_MODE_8_HOUR,
            };
          });
          break;
        case TREND_MODE.TREND_MODE_24_HOUR:
          setPageState((state) => {
            return {
              ...state,
              mode: TREND_MODE.TREND_MODE_24_HOUR,
            };
          });
          break;
      }
    }
  };

  const getLastShutDownIndex = (data) => {
    const lastShutDownIndex = data.findLastIndex(el => el.turnOnOff === true);
    return lastShutDownIndex
  }

  useEffect(() => {
    const state = pageState;
    const searchParams = new URLSearchParams();
    searchParams.append("windowState", JSON.stringify(state));
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });

    if (
      pageState?.window?.menu == null ||
      pageState?.window?.menu == undefined
    ) {
      props.navigation.setMenu(pageState.menu);
    }
    props.navigation.addLocalNavigation(localNavigation);
    return () => {
      props.navigation.addLocalNavigation(null);
    };
  }, [pageState]);

  useEffect(() => {
    updateNavigation();
  }, [pageState.mode]);


  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const now = Date.now();
    setTimestamps(getTimestamps(pageState.mode));
  }, [pageState.mode, time]);

  const data = generateTestChartData();
  return (
    <Box sx={{ width: "100%", height: "100%", background: "black",position:"relative"}}>
      <Box sx={{ width: "100%", height: "100%", background: "black" }}>
        <UPlotChart
          mode={pageState.mode}
          timestamps={timestamps}
          xRange={[0, getTrendEntryNumber(pageState.mode)]}
          data={deviceDataToTrendData(
            deviceData,
            getTrendEntryNumber(pageState.mode),
            pageState.mode
          )}
        />
      </Box>
      <Typography sx={{position:"absolute",top:12,left:4,fontWeight:"bold",color:colors().SPO2}}>SpO2</Typography>
      <Box sx={{position:"absolute",top:12,left:75,fontWeight:"bold",color:colors().SPO2}}>        <Box
          component="img"
          src={hearth}
          alt="Pulse"
          sx={{
            width: "20px",
            height: "20px",
          }}
        /></Box>
      <Typography sx={{position:"absolute",top:12,right:45,fontWeight:"bold",color:colors().O2}}>O2</Typography>
      {pageState.mode!=TREND_MODE.TREND_MODE_12_MIN?renderGraphLegend():null}
    </Box>
  );
};

const renderGraphLegend=()=>{
  return(
    <Box sx={{width:"140px",height:"75px",position:"absolute",right:0,bottom:-77,background:"black",pl:1, border: 1, mr: 2, mb: 3}}>
    <Box sx={{display:"flex",width:"100%",flexDirection:"row",justifyContent:"start",alignItems:"center"}}>
      <Box sx={{display:"flex",flexDirection:"row",width:"20px",height:"25px",justifyContent:"center",alignContent:"center",alignItems:"center",mr:1}}>
        <Box sx={{width:"1px",height:"18px",background:colors().COLORS_SUBITEM_DEFAULT}}/>
      </Box>
      <Box sx={{display:"flex",flexDirection:"row",width:"90px",height:"100%",justifyContent:"end"}}>
        <Typography sx={{width:"100%",fontSize:"12px",color:colors().COLORS_SUBITEM_DEFAULT}}> <Translate value={"DeviceOnOff"}/> </Typography>
      </Box>
    </Box>

    <Box sx={{display:"flex",width:"100%",flexDirection:"row",justifyContent:"start",alignItems:"center"}}>
      <Box sx={{display:"flex",flexDirection:"column",width:"20px",height:"25px",justifyContent:"center",alignContent:"center",alignItems:"center",mr:1}}>
        <Box sx={{width:"1px",height:"6px",background:colors().COLORS_SUBITEM_DEFAULT,mb:"4px"}}/>
        <Box sx={{width:"1px",height:"6px",background:colors().COLORS_SUBITEM_DEFAULT}}/>
      </Box>
      <Box sx={{display:"flex",flexDirection:"row",width:"90px",height:"100%",justifyContent:"end"}}>
        <Typography sx={{width:"100%",fontSize:"12px",color:colors().COLORS_SUBITEM_DEFAULT}}> <Translate value={"NewPatient"}/> </Typography>
      </Box>
    </Box>

    <Box sx={{display:"flex",width:"100%",flexDirection:"row",justifyContent:"start",alignItems:"center"}}>
      <Box sx={{display:"flex",flexDirection:"row",width:"20px",height:"25px",justifyContent:"center",alignContent:"start",mr:1}}>
        <DownArrow sx={{width:"15px",height:"25px", color:colors().COLORS_SUBITEM_DEFAULT}}/>
      </Box>
      <Box sx={{display:"flex",flexDirection:"row",width:"90px",height:"100%",justifyContent:"end"}}>
        <Typography sx={{width:"100%",fontSize:"12px",color:colors().COLORS_SUBITEM_DEFAULT}}> <Translate value={"ProfileChange"}/> </Typography>
      </Box>
    </Box>
  </Box>
  )
}

export const getTrendEntryNumber = (mode) => {
  if (mode === TREND_MODE.TREND_MODE_12_MIN) {
    return 13.35 * 60;
  }
  if (mode === TREND_MODE.TREND_MODE_1_HOUR) {
    return ((60 * 68))-13;
  }

  if (mode === TREND_MODE.TREND_MODE_8_HOUR) {
    return (8 * 60 * 84);
  }

  if (mode === TREND_MODE.TREND_MODE_24_HOUR) {
    return (24 * 60 * 56);
  }
};
export const getTimestamps = (mode) => {
  const now = Date.now();

  if (mode === TREND_MODE.TREND_MODE_12_MIN) {
    return [
      getTimeStringFromDate(now - 12 * 60 * 1000),
      getTimeStringFromDate(now - 9 * 60 * 1000),
      getTimeStringFromDate(now - 6 * 60 * 1000),
      getTimeStringFromDate(now - 3 * 60 * 1000),
      getTimeStringFromDate(now),
    ];
  }
  if (mode === TREND_MODE.TREND_MODE_1_HOUR) {
    return [
      getTimeStringFromDate(now - 60 * 60 * 1000), // T-01:00
      getTimeStringFromDate(now - 45 * 60 * 1000), // T-00:45
      getTimeStringFromDate(now - 30 * 60 * 1000), // T-00:30
      getTimeStringFromDate(now - 15 * 60 * 1000), // T-00:15
      getTimeStringFromDate(now),
    ];
  }

  if (mode === TREND_MODE.TREND_MODE_8_HOUR) {
    return [
      getTimeStringFromDate(now - 8 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 6 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 4 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 2 * 60 * 60 * 1000),
      getTimeStringFromDate(now),
    ];
  }

  if (mode === TREND_MODE.TREND_MODE_24_HOUR) {
    return [
      getTimeStringFromDate(now - 24 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 18 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 12 * 60 * 60 * 1000),
      getTimeStringFromDate(now - 6 * 60 * 60 * 1000),
      getTimeStringFromDate(now),
    ];
  }
};
